import DOMPurify from 'dompurify';
import { RICH_TEXT_CLASS } from '@/lib/rich-text';
import type { ResolvedCustomerTerms } from '@/lib/terms/clientTerms';
import { cn } from '@/lib/utils';

/**
 * Terms body as the customer reads it, on the public quote, invoice and
 * proposal alike.
 *
 * The three pages had three copies of this branch and had drifted apart: the
 * proposal never rendered HTML at all, so a T&C template — always editor HTML —
 * reached the customer as raw `<p>`/`<ul>` markup. One renderer means a fix to
 * any of it lands on every document a customer is asked to agree to.
 *
 * Callers own the section chrome (heading, card, scroll anchor) and pass their
 * own type scale via `className`; `hasTerms` on the resolved value decides
 * whether the section renders at all.
 */
export function CustomerTermsBody({
  terms,
  className,
}: {
  terms: ResolvedCustomerTerms;
  className?: string;
}) {
  if (!terms.hasTerms) return null;

  return terms.isHtml ? (
    <div
      className={cn('max-w-none', RICH_TEXT_CLASS, className)}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(terms.text) }}
    />
  ) : (
    <p className={cn('whitespace-pre-wrap font-sans', className)}>{terms.text}</p>
  );
}
